// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "li a[data-v-d1a63698]{display:flex;align-items:center;justify-content:space-between}li span[data-v-d1a63698]{margin-right:5px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
